<div class="challenge-result-container" *ngIf="shouldDisplayModal">
  <div class="challenge-result" [ngClass]="{
    'defeat-challenge-result': false
    }">
    <div class="close-icon">
      <button (click)="closeModal()" type="button" class=""></button>
    </div>
    <div class="body-challenge-result">
      <img src="../App_Themes/clearview-default/images/challenges/shadowboxing/shadow_boxing.svg"
        alt="Shadow Boxing Icon" width="75" height="75" class="icon-75" />
      <h1 class="title" [ngClass]="{
        'challenge-ended': isChallengeLoss
      }" cvLocalizedText langSection="Challenges" [langKey]="title">Great Punch!</h1>

      <div class="reward-content" *ngIf="isChallengeWon">
        <img src="../App_Themes/clearview-default/images/challenges/shadowboxing/Gems.svg" alt="Shadow Boxing Icon"
          width="18" height="18" class="icon-18">
        <span class="reward-text">{{ reward }}</span>
      </div>

      <p class="description" cvLocalizedText langSection="Challenges" [langKey]="description">Keep punching until you win this challenge.</p>
      <div class="btn-close">
        <button (click)="closeModal()" cvLocalizedText langSection="Challenges" langKey="close" type="button">
          Close
        </button>
      </div>
    </div>
  </div>
</div>